import zhLocale from 'view-design/src/locale/lang/zh-CN'
import enLocale from 'view-design/src/locale/lang/en-US'

const lang = {
  en: {},
  zh: {},
}

const modules = [
  'streams',
  'tables',
  'rules',
  'plugins',
  'common',
  'nodes',
  'settings',
  'help',
  'system',
  'sql',
  'admin',
  'extension',
  'services',
  'configuration',
  'schema',
  'upload',
]

modules.forEach((key) => {
  // eslint-disable-next-line
  const value = require(`./${key}`).default

  Object.keys(value).forEach((k) => {
    const { en, zh } = value[k]
    lang.en[key] = lang.en[key] || {}
    lang.zh[key] = lang.zh[key] || {}

    lang.en[key][k] = en
    lang.zh[key][k] = zh
  })
})

const messages = {
  zh: Object.assign(lang.zh, zhLocale),
  en: Object.assign(lang.en, enLocale),
}

export default messages
